/* eslint-disable */
'use strict';

const Mix = {
    init: function() {
        const stepByStep = document.querySelector('.step-by-step');
        if (stepByStep) {
            this.stepByStepBubbles();
        }
        if(window.innerWidth < 768) {
            this.footerLinksResponsive();
        }
        if(window.innerWidth < 992) {
            this.singleProductResponsiveAppend();
            const blogArticle = document.querySelector('.blog-article');
            if (blogArticle) {
                this.blogArticleTableOfContentMobile();
            }
        }
        const blogAll = document.querySelector('.blog-all');
        if (blogAll) {
            if(window.innerWidth > 991) {
                this.blogAllPillsActiveClass();
            }
            if(window.innerWidth < 992) {
                this.blogAllPillsResponsive();
            }
        }
        const accordion = document.querySelector('.product-single__right-accordions');
        if(accordion) {
            this.accordion();
        }
        const accordionAllOpen = document.querySelector('.product-single__right-accordions--all-open');
        if(accordionAllOpen) {
            this.accordionAllOpen();
        }
		const marquee = document.querySelector('.usp-scrolling-marquee__wrap');
	    this.marquee();		

        const marqueeAlt = document.querySelector('.usp-scrolling-marquee--alt .usp-scrolling-marquee__wrap');
        if (marqueeAlt) {
            this.marqueeAlt();
        }
        const gelVsPills = document.querySelector('.gel-vs-pills');
        if (gelVsPills) {
            this.gelVsPillsChangeLayout();
        }
        const videoContainer = document.querySelector('.js-video-container');
        if(videoContainer) {
            this.videoPlayPause();
        }
        const successStoriesModalTrigger = document.querySelector('.js-success-stories-modal-trigger');
        if(successStoriesModalTrigger) {
            this.successStoriesModalPopup();
        }
        this.showPassword();
        const toc = document.getElementById('toc-container');
        if(toc) {
            this.legalPagesTableOfContent();
        }
        const blogArticleTable = document.querySelector('.js-blog-article__left');
        if(blogArticleTable) {
            this.blogArticleTableStickyOnScroll();
        }
        const blogArticleProgressBar = document.querySelector('.progress-bar');
        if(blogArticleProgressBar) {
            this.blogArticleProgressBar();
        }
        const ingredientsPopupTrigger = document.querySelector('.js-product-single__right-facts-link');
        const ingredientsPopup = document.querySelector('.js-product-single__ingredients-modal');
        if(ingredientsPopupTrigger && ingredientsPopup) {
            this.productSingleIngredientsPopup();
        }
        // const stickyCta = document.querySelector('.sticky-cta');
        // if(stickyCta) {
        //     setTimeout(() => {
        //         this.productSingleStickyCTA();
        //     }, 100);
        // }
    },

    stepByStepBubbles: function() {
        const bubbleIcons = document.querySelectorAll('.step-by-step__bubble-icon');
        const bubbleMainImgs = document.querySelectorAll('.step-by-step__bubble-main-image');
        
        bubbleIcons[0].classList.add('active');
        bubbleMainImgs[0].classList.add('active');
        const maxData = bubbleIcons.length;
        let i = 2;
        bubbleIcons.forEach(function(bubbleIcon) {
            bubbleIcon.addEventListener('click', function() {
                const dataTab = parseInt(this.getAttribute('data-tab'));
                bubbleIcons.forEach(function(bubbleIcon) {
                    bubbleIcon.classList.remove('active');
                });
                this.classList.add('active');
                bubbleMainImgs.forEach(function(bubbleMainImg) {
                    bubbleMainImg.classList.remove('active');
                });
                document.querySelector(`.step-by-step__bubble-main-image${dataTab}`).classList.add('active');
                i = dataTab;
            });
        });

        setInterval(function () {
            if (i > maxData) i = 1;
            bubbleIcons.forEach(function(bubbleIcon) {
                bubbleIcon.classList.remove('active');
            });
            bubbleMainImgs.forEach(function(bubbleMainImg) {
                bubbleMainImg.classList.remove('active');
            });
            document.querySelector(`.step-by-step__bubble-icon[data-tab='${i}']`).classList.add('active');
            document.querySelector(`.step-by-step__bubble-main-image${i}`).classList.add('active');
            i++;
        }, 5000);
    },

    footerLinksResponsive: function() {
        const footerLinkTriggers = document.querySelectorAll('.js-site-footer__middle-box-title');

        footerLinkTriggers.forEach(link => link.addEventListener('click', () => {
            const sibling = link.nextElementSibling;

            if (sibling.classList.contains('is-open')) {
                sibling.classList.remove('is-open');
                link.classList.remove('is-active');
            } else {
                removeActiveClassesFooterLinks();
                sibling.classList.add('is-open');
                link.classList.add('is-active');
            }
        }));

        function removeActiveClassesFooterLinks() {
            footerLinkTriggers.forEach(link => {
                link.classList.remove('is-active');
                link.nextElementSibling.classList.remove('is-open');
            });
        }
    },

    blogAllPillsActiveClass: function() {
        document.querySelectorAll('.blog-all__pills span').forEach(function(item) {
            item.addEventListener('click', setActive.bind(item));
          });

          function setActive() {
            const listItems = document.querySelectorAll('.blog-all__pills span');
            for (let i = 0; i < listItems.length; i++) {
              if (listItems[i] !== this) {
                listItems[i].classList.remove('is-active');
              }
            }
            this.classList.toggle('is-active');
          }
    },

    blogAllPillsResponsive: function() {
        document.querySelectorAll('.blog-all__pills').forEach(function(select) {
            select.addEventListener('click', function() {
            var is_open = this.classList.contains('open');
            if (is_open) {
                this.classList.remove('open');
            } else {
                this.classList.add('open');
            }
            });
        });

        document.querySelectorAll('.blog-all__pills span').forEach(function(li) {
            li.addEventListener('click', function() {
                var selected_value = this.innerHTML;
                var first_li = document.querySelector('.blog-all__pills span:first-child').innerHTML;
                document.querySelector('.blog-all__pills span:first-child').innerHTML = selected_value;
                this.innerHTML = first_li;
                first_li.classList.add('is-active');
            });
        });

        document.addEventListener('mouseup', function(event) {
            var target = event.target;
            var select = document.querySelector('.blog-all__pills');
            if (!select.contains(target)) {
            select.classList.remove('open');
            }
        });
    },

    accordion: function() {
        const domAccShown = document.querySelectorAll('.js-box-shown');
        const domAccHidden = document.querySelectorAll('.js-box-hidden');
        const classActive = 'is-active';         

        if(domAccShown) {
            const firtAccordionToOpen = Array.prototype.find.call(domAccShown, function(element) {
                return element.classList.contains('js-box-first-open');
              });
             
            if(firtAccordionToOpen) {
                const parent = firtAccordionToOpen.parentElement;
                const hiddenContent = firtAccordionToOpen.nextElementSibling;

                if(window.innerWidth > 767) {            
                    parent.classList.add(classActive);                    
                    hiddenContent.style.maxHeight = hiddenContent.scrollHeight + "px";                    
                }           
            }             
        }        

        domAccShown.forEach(function(el) {
            el.addEventListener('click', function() {
                const self = this;
                const parent = self.parentElement;
                const hiddenContent = self.nextElementSibling;

                // Currently user can expand more than one accordion at the time.
                // If we want to give him option to expand only one item at the time, then uncomment this code.
                //
                // domAccShown.forEach(function(otherEl) {
                //     if (otherEl !== self) {
                //         const otherParent = otherEl.parentElement;
                //         const otherHiddenContent = otherEl.nextElementSibling;

                //         if (otherParent.classList.contains(classActive)) {
                //             otherParent.classList.remove(classActive);
                //             otherHiddenContent.style.maxHeight = null; // Reset to allow transition
                //         }
                //     }
                // });

                if (parent.classList.contains(classActive)) {
                    parent.classList.remove(classActive);
                    hiddenContent.style.maxHeight = null;
                } else {
                    parent.classList.add(classActive);
                    hiddenContent.style.maxHeight = hiddenContent.scrollHeight + "px";
                }
            });
        });
    },

    accordionAllOpen: function() {
        const domAccShown = document.querySelectorAll('.js-box-shown-all-open');
        const domAccHidden = document.querySelectorAll('.js-box-hidden-all-open');
        const classActive = 'is-active';

        domAccShown.forEach(function(el) {
            el.addEventListener('click', function() {
                const self = this;
                const parent = self.parentElement;
                const hiddenContent = self.nextElementSibling;

                if (parent.classList.contains(classActive)) {
                    parent.classList.remove(classActive);
                    hiddenContent.style.maxHeight = null;
                } else {
                    parent.classList.add(classActive);
                    hiddenContent.style.maxHeight = hiddenContent.scrollHeight + "px";
                }
            });
        });
    },

    singleProductResponsiveAppend: function() {
        const singleProductLeft = document.querySelector('.js-product-single__left');
        const singleProductRight = document.querySelector('.js-product-single__right');
        const singleProductRightUpper = document.querySelector('.js-product-single__right-upper');
        const singleProductLeftTestimonials = document.querySelector('.js-product-single__left-testimonials');

        if(singleProductLeft && singleProductRightUpper) {
            singleProductLeft.insertBefore(singleProductRightUpper, singleProductLeft.firstChild);
        }

        if(singleProductRight && singleProductLeftTestimonials) {
            singleProductRight.appendChild(singleProductLeftTestimonials);
        }
    },

    marquee() { 
		const parentContainer = document.querySelectorAll('.usp-scrolling-marquee__wrap');

        if(parentContainer) {
            parentContainer.forEach(container => {
                var shouldDoubleElements = false;

                const firstParent = container.parentElement;
                if(firstParent) {
                    const secondParent = firstParent.parentElement;
                    
                    if(secondParent) {
                        if(secondParent.classList.contains('usp-scrolling-marquee--alt')) {
                            shouldDoubleElements = true;
                        }
                    }
                }

                if(window.innerWidth < 568 && shouldDoubleElements ||
                    window.innerWidth > 567) {

                    const childElement = container.querySelector('.usp-scrolling-marquee-logos');

                    for (let i = 0; i < 20; i++) {
                        const clone = childElement.cloneNode(true);
                        container.appendChild(clone);
                    }
                }
            })
        }		
	},

    marqueeAlt() {
		const parentContainer = document.querySelector('.usp-scrolling-marquee--alt .usp-scrolling-marquee__wrap');
		const childElement = parentContainer.querySelector('.usp-scrolling-marquee--alt .usp-scrolling-marquee-logos');

		for (let i = 0; i < 20; i++) {
			const clone = childElement.cloneNode(true);
			parentContainer.appendChild(clone);
		}
	},

    gelVsPillsChangeLayout: function() {
        const boxRightInfoElements = document.querySelectorAll('.gel-vs-pills__box-right-info');
        const boxWrapElement = document.querySelector('.gel-vs-pills__box-wrap');

        if (boxRightInfoElements.length > 5) {
            boxWrapElement.classList.add('more-than-five');
        }
    },

    videoPlayPause: function() {
        const videoContainers = document.querySelectorAll('.js-video-container');

        videoContainers.forEach(function(container) {
            const videoElement = container.querySelector('.js-video');
            const playPauseButton = container;

            playPauseButton.addEventListener('click', function() {
                const isPlaying = container.classList.contains('playing');

                document.querySelectorAll('.js-video-container').forEach(function(otherContainer) {
                    if (otherContainer !== container && otherContainer.classList.contains('playing')) {
                        otherContainer.classList.remove('playing');
                        otherContainer.querySelector('.js-video').pause();
                    }
                });

                container.classList.toggle('playing', !isPlaying);

                if (!isPlaying) {
                    videoElement.play();
                } else {
                    videoElement.pause();
                }
            });
        });
    },

    successStoriesModalPopup: function() {
        const triggerButtons = document.querySelectorAll('.js-success-stories-modal-trigger');
        const body = document.querySelector('body');
        const html = document.querySelector('html');

        function openModal(modal) {
            modal.classList.add('is-active');
            body.classList.add('prevent-scroll');
            html.classList.add('prevent-scroll');
        }

        function closeModal(modal) {
            modal.classList.remove('is-active');
            body.classList.remove('prevent-scroll');
            html.classList.remove('prevent-scroll');
        }

        triggerButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                const popupNum = button.dataset.popup;
                const modal = document.querySelector('.js-success-stories-modal--' + popupNum);
                openModal(modal);
            });
        });

        document.querySelectorAll('.js-success-stories-modal__close-icon').forEach(function(icon) {
            icon.addEventListener('click', function() {
                document.querySelectorAll('.js-success-stories-modal').forEach(function(modal) {
                    const popupNum = modal.dataset.popup;
                    closeModal(modal);
                });
            });
        });

        document.querySelectorAll('.js-success-stories-modal').forEach(function(modal) {
            modal.addEventListener('click', function(event) {
                const popupNum = modal.dataset.popup;
                if (!modal.querySelector('.js-success-stories-modal__inner').contains(event.target)) {
                    closeModal(modal);
                }
            });
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                document.querySelectorAll('.js-success-stories-modal').forEach(function(modal) {
                    const popupNum = modal.dataset.popup;
                    closeModal(modal);
                });
            }
        });
    },

    showPassword: function () {
		setTimeout(function () {
			document.querySelectorAll('.form-pass-icon').forEach(function (icon) {
				icon.addEventListener('click', function () {
					const input = this.parentElement.querySelector('input');
					if (input.type === 'password') {
						input.type = 'text';
						this.classList.add('is-active');
					} else {
						input.type = 'password';
						this.classList.remove('is-active');
					}
				});
			});
		}, 200);
	},

    legalPagesTableOfContent: function() {
        const elTableOfContent = document.querySelectorAll('.js-table-of-content');
        const headers = document.querySelectorAll('.entry-content h3');

        if(!!headers.length) {
            const toc = document.getElementById('toc');
            const offset = 150;
            if (!!elTableOfContent.length) {
                elTableOfContent.forEach(el => el.style.visibility = 'visible');
            }
            headers.forEach((header, index) => {
                if (!header.id) {
                    header.id = `section-${index + 1}`;
                }
                const listItem = document.createElement('li');
                const anchor = document.createElement('a');
                anchor.href = `#${header.id}`;
                anchor.textContent = header.textContent;
                anchor.addEventListener('click', function(event) {
                    event.preventDefault();
                    const target = document.getElementById(header.id);
                    const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                });
                listItem.appendChild(anchor);
                toc.appendChild(listItem);
            });
        }
    },

    blogArticleTableStickyOnScroll: function() {
		window.addEventListener('scroll', function() {
			const containerLeft = document.querySelector('.js-blog-article__left');
			const container = document.querySelector('.js-blog-article__upper');

			if (container && containerLeft) {
				const containerBottom = container.offsetTop + container.offsetHeight - containerLeft.offsetHeight;
				const headerHeight = 150;

				if (window.pageYOffset >= container.offsetTop - headerHeight && window.pageYOffset <= containerBottom) {
					containerLeft.style.position = 'sticky';
					containerLeft.style.top = headerHeight + 'px';
					containerLeft.style.transition = 'top 0.3s ease-in-out';
					containerLeft.style.width = containerLeft.offsetWidth + 'px';
				} else if (window.pageYOffset > containerBottom) {
					containerLeft.style.position = 'absolute';
					containerLeft.style.bottom = '0';
					containerLeft.style.top = 'auto';
					containerLeft.style.transition = 'none';
				} else {
					containerLeft.style.position = 'static';
					containerLeft.style.transition = 'none';
				}
			} 
		}); 
	},

    blogArticleProgressBar: function() {
        const progressBar = document.querySelector('.progress-bar');
        const progressBarFill = document.querySelector('.progress-bar-fill');
        const blogArticleRight = document.querySelector('.blog-article__right');
        let header = document.querySelector('header');

        const storedValue = window.sessionStorage.getItem('promoClosed');
        if(storedValue){
            if(storedValue === "true"){
                header = document.querySelector('.site-header');
            }
        }        
        
        let headerHeight = header.offsetHeight;
        let articleStart = blogArticleRight.offsetTop - headerHeight + 500;
        let articleEnd = blogArticleRight.offsetTop + blogArticleRight.scrollHeight - window.innerHeight + 200;

        function updateProgressBar() {
            const scrollTop = window.scrollY;           
            if (scrollTop > 2 && scrollTop >= articleStart && scrollTop <= articleEnd) {
                const maxScroll = blogArticleRight.scrollHeight - window.innerHeight + headerHeight;
                const progress = (scrollTop - articleStart) / maxScroll;
                progressBarFill.style.width = (progress * 100) + '%';
            }
        }
 
        function onScroll() {
            const scrollTop = window.scrollY;

            if (scrollTop > 2 && scrollTop >= articleStart && scrollTop <= articleEnd) {
                progressBar.style.display = 'block';
                progressBar.style.top = headerHeight + 'px';
            } else {
                progressBar.style.display = 'none';
            }

            updateProgressBar();
        }

        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', function() {
            headerHeight = header.offsetHeight;
            articleStart = blogArticleRight.offsetTop - headerHeight;
            articleEnd = blogArticleRight.offsetTop + blogArticleRight.scrollHeight - window.innerHeight;
            updateProgressBar();
        });

        onScroll();
    },

    blogArticleTableOfContentMobile: function() {
        const tocContainer = document.getElementById('toc-container');
        const entryWrap = document.querySelector('.blog-article__right-entry-wrap');
        const buttonWrap = document.querySelector('.blog-article__right-content-mobile-button-wrap');

        if (tocContainer && buttonWrap) {
            buttonWrap.appendChild(tocContainer);
            buttonWrap.addEventListener('click', function() {
                tocContainer.classList.toggle('is-visible');
            });
            document.addEventListener('click', function(event) {
                if (!buttonWrap.contains(event.target) && tocContainer.classList.contains('is-visible')) {
                    tocContainer.classList.remove('is-visible');
                }
            });
        }

        window.addEventListener('scroll', function() {
            if(entryWrap) {
                const entryWrapRect = entryWrap.getBoundingClientRect();
                const isInViewport = entryWrapRect.top < window.innerHeight && entryWrapRect.bottom > 0;

                if (isInViewport) {
                    buttonWrap.style.display = 'block';
                } else {
                    buttonWrap.style.display = 'none';
                    tocContainer.classList.remove('is-visible');
                }
            }
        });
    },

    productSingleIngredientsPopup: function() {
        const body = document.querySelector('body');
        const html = document.querySelector('html');
        const productSingleIngredientsPopupBtn = document.querySelector('.js-product-single__right-facts-link');
        const productSingleIngredientsPopupHolder = document.querySelector('.js-product-single__ingredients-modal');
        const productSingleIngredientsPopupInner = document.querySelector('.js-product-single__ingredients-modal-inner');
        const productSingleIngredientsPopupIconClose = document.querySelector('.js-product-single__ingredients-modal-close');

        productSingleIngredientsPopupBtn.addEventListener('click', ()=> {
            productSingleIngredientsPopupHolder.classList.add('is-visible');
            body.classList.add('prevent-scroll');
            html.classList.add('prevent-scroll');
        });

        productSingleIngredientsPopupIconClose.addEventListener('click', function() {
            productSingleIngredientsPopupHolder.classList.remove('is-visible');
            body.classList.remove('prevent-scroll');
            html.classList.remove('prevent-scroll');
        });

        productSingleIngredientsPopupHolder.addEventListener('click', function(event) {
            if (!productSingleIngredientsPopupInner.contains(event.target)) {
                productSingleIngredientsPopupHolder.classList.remove('is-visible');
                body.classList.remove('prevent-scroll');
                html.classList.remove('prevent-scroll');
            }
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                productSingleIngredientsPopupHolder.classList.remove('is-visible');
                body.classList.remove('prevent-scroll');
                html.classList.remove('prevent-scroll');
            }
        });
    },
    // productSingleStickyCTA: function() {
    //     window.addEventListener('scroll', function() {
    //         const productSingle = document.querySelector('.product-single');
    //         const stickyCta = document.querySelector('.sticky-cta');
    //         const siteHeader = document.querySelector('.header-main');
    //         const footer = document.querySelector('.site-footer');
    //         const footerTop = footer.offsetTop;
    //         const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //         const productSingleBounding = productSingle.getBoundingClientRect();

    //         if (productSingleBounding.bottom <= 0) {
    //             stickyCta.classList.add('is-visible');
    //             siteHeader.classList.add('hidden-when-sticky-cta');
    //         } else {
    //             stickyCta.classList.remove('is-visible');
    //             siteHeader.classList.remove('hidden-when-sticky-cta');
    //         }

    //         if (scrollTop >= footerTop) {
    //             stickyCta.classList.remove('is-visible');
    //             siteHeader.classList.remove('hidden-when-sticky-cta');
    //         }
    //     });
    //     if(document.querySelector('.js-sticky-cta__btn')) {
    //         const scrollBtn = document.querySelector('.js-sticky-cta__btn');
    //         const productSingle = document.querySelector('.product-single');
    //         scrollBtn.addEventListener('click', function() {
    //             productSingle.scrollIntoView({ behavior: 'smooth' });
    //         });
    //     }
    // },
};

export default Mix;
